import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    confirmClosing: 'Confirm closing',
    deletionError: 'An error occurred while closing this account',
    description: [
      {
        items: [
          'the rejection of future incoming direct debits or transfers to this wallet',
          'the cancellation of all scheduled transfers from this account',
          'the revocation of direct debit mandates linked to this account',
        ],
        title: 'This leads to:',
      },
      {
        items: [
          'to your bank statements',
          'to your transaction history and receipts',
        ],
        title: 'You will still have access to:',
      },
    ],
    seeAllAccounts: 'View my wallets',
    success: {
      description: '{name} has been successfully closed',
    },
    title: 'Close {name}',
  },
  fr: {
    confirmClosing: 'Confirmer la clôture',
    deletionError:
      'Une erreur est survenue lors de la clôture de votre compte.',
    description: [
      {
        items: [
          'le rejet des prélèvements ou virements entrants à venir sur ce compte',
          'l’annulation des virements programmés depuis ce compte',
          'la révocation des mandats de prélèvements liés à ce compte',
        ],
        title: 'Cette action entraîne définitivement :',
      },
      {
        items: [
          'à vos relevés bancaires',
          'à l’historique de vos transactions et reçus',
        ],
        title: 'Vous aurez toujours accès :',
      },
    ],
    seeAllAccounts: 'Voir mes comptes',
    success: {
      description: '{name} a bien été clôturé',
    },
    title: 'Clôturer {name}',
  },
} as const);

export default locales;
